// Common components
import { useEffect, useState } from 'react';
import Sidebar from '../../components/common/Sidebar';
import Header from '../../components/common/Header';
import Footer from '../../components/Footer';

import CurrentAndUpcomingFetes from 'components/dashboard/CurrentAndUpcomingFetes';
import PastFetes from 'components/dashboard/PastFetes';
import useAppState from 'context/useAppState';
import allImgPaths from "assets/images";
import { useNavigate } from 'react-router-dom';
import RecentActivity from './RecentActivity';
import Toast from 'components/common/Toast';
import ConfirmationModal from 'components/common/modal/ConfirmationModal';
import DashboardLoader from 'components/loaders/Dashboard';
import RemoveMember from 'components/common/modal/RemoveMember';
import EditWarning from 'components/common/modal/EditWarning';
import DeleteWarning from 'components/common/modal/DeleteWarning';
import AttendeeListModal from 'components/common/modal/AttendeeListModal';
import SendTo from 'components/common/modal/SentTo';
import VendorDetailsModal from 'components/common/modal/VendorDetailsModal';
import ChangeFeteImgModal from 'components/common/modal/ChangeFeteImgModal';
import LogisticsModal from 'components/common/modal/LogisticsModal';
import RfpVendorBoxModal from 'components/rfp/RfpVendorBoxModal';

function Dashboard() {
	const navigate = useNavigate();
	const {
		fetchUserEvents,
		currentAndUpcomingEvents,
		pastEvents,
		isEventListAPICall
	} = useAppState("eventList");

	const { resetStateToDefaults: resetChatToDefaults, createNewEvent } = useAppState('chatBox');
	const { newFeteDetails } = useAppState('newFeteChat');

	const { isTeamChanged } = useAppState('selectTeam');

	useEffect(() => {
		if (isEventListAPICall) {
			setTimeout(() => {
				fetchUserEvents()
			}, 3000)
		}
	}, [isEventListAPICall]);

	const handleNewFeteClick = async () => {
		resetChatToDefaults();
		const newFete = await createNewEvent({ ...newFeteDetails, is_draft: true });
		const event = newFete?.data
		navigate(`/fete/new/${event?._id}`);
	}

	const [isShowModal, setIsShowModal] = useState(false);

    const handleModal = () => {
        setIsShowModal(!isShowModal);
    }

	return (
		<div className="dashboard-wrapper flex">
			{/* Sidebar */}
			<Sidebar />

			{/* dashboard main */}
			<div className="w-[calc(100%_-_72px)] ml-auto">
				{/* Hedaer */}
				<Header />

				{
					isTeamChanged && <DashboardLoader count={1} />
				}


				{/* Search Bar */}
				<div className="h-[calc(100vh_-_127px)] overflow-y-auto">
					{/* <div className="bg-gradient-1 rounded-[10px] py-10 px-16 mb-10 mx-10">
						<div className="border border-[#D0D5DD] rounded-lg bg-white py-4 px-3.5 flex items-center mb-4">
							<img className='cursor-pointer' src={allImgPaths.searchIcon} alt="search icon" />
							<input className='inline-block w-full placeholder:text-[#667085] text-[101828] pl-2 pr-2' placeholder='Search or ask anything here...' type="text" />
							<img className='cursor-pointer' src={allImgPaths.miceIcon} alt="mice icon" />
						</div>

						<div className="flex flex-wrap gap-x-2 justify-center">
							<span className='text-sm font-interMedium text-[#344054] py-1 px-2 rounded border border-[#D0D5DD] bg-white cursor-pointer'>Status of venue quotations</span>

							<span className='text-sm font-interMedium text-[#344054] py-1 px-2 rounded border border-[#D0D5DD] bg-white cursor-pointer'>Latest corporate decor themes</span>

							<span className='text-sm font-interMedium text-[#344054] py-1 px-2 rounded border border-[#D0D5DD] bg-white cursor-pointer'>Survey result for last events</span>

							<span className='text-sm font-interMedium text-[#344054] py-1 px-2 rounded border border-[#D0D5DD] bg-white cursor-pointer'>Beaches suitable for corporate events</span>
						</div>
					</div> */}

					{/* Create New Fete */}
					<div className="mx-10">
						<div className="pt-10 pb-16">
							<div className="w-[540px] mx-auto relative text-center bg-round-pattern-lg">
								{/* <img src={allImgPaths.feteGif} alt="" /> */}
								<img className='mx-auto' src="/animated-svg/new-fete-animated-blue.svg" alt="" />
								<div className="-mt-[115px]">
									<div className='pb-1.5 relative z-10'>
										<p className='text-xl text-[#101828] pb-[3px]'><span className='font-interSemiBold text-xl text-[#101828] text-center'>Elevate</span> Your Events. </p>

										<p className='text-xl text-[#101828]'>Craft Unforgettable
											<span className='font-interSemiBold text-xl text-[#101828]'> Experiences</span>
										</p>
									</div>

									<div className="mt-3 mx-auto flex justify-center relative z-10">
										<button onClick={handleNewFeteClick} className='submit-btn-blue flex justify-center items-center gap-x-2 !px-5 -ml-2 blue-btn-hover'> <img src={allImgPaths.plusIcon} alt="plus" /> New Fete</button>
									</div>
								</div>
							</div>
						</div>

					</div>

					{/* Recent Activity   */}
					<RecentActivity />

					{/* Upcoming Fete */}
					<CurrentAndUpcomingFetes currentAndUpcomingEvents={currentAndUpcomingEvents} />

					{/* Past Fetes  */}
					<PastFetes pastEvents={pastEvents} />

					{/* Trending */}
					<div className="bg-[#fff] border-b border-[#EAECF0] pb-6 px-10">
						<h3 className='text-[#101828] text-2xl font-interSemiBold pb-6 pt-6'>Trending</h3>

						<div className="flex gap-x-8 overflow-x-auto w-[calc(100vw_-_132px)] pb-7 custom-cursor-pointer on-hover-show-scrollbar">
							{/* cards */}
							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>

							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>

							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>

							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>

							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>

							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>

							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>
						</div>
					</div>

					{/* Events Happening Near you  */}
					<div className="bg-[#F9FAFB] pb-6 px-10">
						<h3 className='text-[#101828] text-2xl font-interSemiBold pb-6 pt-6'>Events Happening Near you</h3>

						<div className="flex gap-x-8 overflow-x-auto w-[calc(100vw_-_132px)] pb-7 custom-cursor-pointer on-hover-show-scrollbar">
							{/* cards */}
							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>

							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>

							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>

							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>

							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>

							<div className="w-[280px] cursor-pointer border border-[#D7DFE9] hover:shadow-xl rounded-xl transition-all duration-300">
								<div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
									<img
										className="absolute top-2 right-2 w-6 h-6 cursor-pointer"
										src={allImgPaths.heartIconWhite}
										alt=""
									/>
									<img
										className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[324px] h-[202px]"
										src={allImgPaths.dummyImg1}
										alt="img"
									/>
								</div>
								<div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
									<div className="flex items-center gap-x-2 justify-between w-full">
										<p className="text-[#4B3BF7] text-sm font-interSemiBold">Celebration</p>
										<span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
											In-Person
										</span>
									</div>
								</div>
								<div className="flex items-start justify-between px-3">
									<h3 className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
										Good Will Hunting
									</h3>
								</div>
								<p className="text-[#475467] line-clamp-1 px-3 h-7">
									To be determined based on event details
								</p>
								<div className="px-3 pb-3 pt-2">
									<p className="text-[#101828] text-xs font-interMedium">31 July 2024</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* <ConfirmationModal /> */}
				{/* <RfpVendor /> */}
				{/* <AttendeeListModal /> */}
				{/* <SendTo /> */}
				{/* <VendorDetailsModal data={{title: 'InterContinental New York Barclay'}} isShow={true} setIsShow={()=> {}} /> */}
				{/* <ChangeFeteImgModal
					isShow={false} 
					setIsShow={()=> {}}
				 /> */}
				<Footer />
			</div>
		</div>
	) 
}

export default Dashboard